import { useCallback, useEffect, useRef, useState } from "react";
import { useWindowSize } from "hooks";

const useContentHeight = (initialHeight: number) => {
  const [contentHeight, setContentHeight] = useState(initialHeight);

  const [expanded, setExpandedState] = useState(false);
  const { width } = useWindowSize();
  const contentRef = useRef<HTMLDivElement>(null);

  const handleClick = useCallback(() => {
    setExpandedState((prevState) => !prevState);
  }, []);

  useEffect(() => {
    if (expanded && contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [expanded, width, initialHeight]);

  const [isCloseLabel, setIsCloseLabel] = useState(expanded);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setIsCloseLabel(expanded);
    }, 800);

    return () => clearTimeout(timerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded]);

  return {
    contentHeight,
    expanded,
    contentRef,
    isCloseLabel,
    handleClick,
  };
};

export { useContentHeight };
